import { render } from "./ContactDetail.vue?vue&type=template&id=bee2a7e0&scoped=true"
import script from "./ContactDetail.vue?vue&type=script&lang=js"
export * from "./ContactDetail.vue?vue&type=script&lang=js"

import "@/assets/css/layout.css?vue&type=style&index=0&id=bee2a7e0&scoped=true&lang=css"
import "@/assets/css/contact_detail.css?vue&type=style&index=1&id=bee2a7e0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\info\\Documents\\ownersite.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bee2a7e0"]])

export default __exports__